import * as Sentry from '@sentry/browser'
import { getFunnelFromUrl } from './getFunnelFromUrl'
import { getMetricPath } from '../metrics/captureEvent'
import { getTrackingIds } from '../metrics/getTrackingIds'

/**
 * Sends a 4xx API response to Sentry as an `api-client-error` log instead of
 * an error
 *
 * @param {import('./ApiResponseError').ApiResponseError} error
 */
export function logApiClientError(error) {
  console.warn(error.message)

  if (typeof Sentry.logger?.warn !== 'function') return

  try {
    const { endpoint, status, statusText, message, code } = error.details

    Sentry.logger.warn('api-client-error', {
      event: 'api-client-error',
      endpoint,
      status,
      status_text: statusText,
      message,
      code,
      funnel: getFunnelFromUrl(),
      path: getMetricPath(),
      ...getTrackingIds(),
    })
  } catch (logError) {
    console.warn('Sentry log failed', logError)
  }
}
